<template>
    <v-dialog
        max-width="400"
        transition="dialog-top-transition"
        v-model="isOpenManagementFilterForm"
    >
        <v-card elevation="0">
            <v-card-title primary-title class="justify-center mb-2">
                <div
                    v-if="$vuetify.breakpoint.xs"
                    class="primary--text text-overline ml-2"
                >
                    Filtros
                </div>
                <div
                    v-else
                    class="
                        font-weight-light
                        primary--text
                        text-h4
                        ml-2
                        text-capitalize
                    "
                >
                    Filtros
                </div>
                <div class="ml-auto">
                    <v-switch
                        :value="managementFilterForm.is_active"
                        @click="changeValue()"
                        inset
                        :class="$vuetify.breakpoint.xs ? 'overline' : 'caption'"
                        color="green"
                        :label="
                            managementFilterForm.is_active == null
                                ? 'Todas'
                                : !managementFilterForm.is_active
                                ? 'Inactivas'
                                : 'Activas'
                        "
                    ></v-switch>
                </div>
            </v-card-title>
            <v-card-text>
                <v-row no-gutters>
                    <v-col cols="12">
                        <v-card elevation="0" text class="mt-1 pa-2">
                            <!-- <v-row>
                                <v-col md="12" class="mb-md-1 mt-md-1">
                                    <h4 class="font-weight-light primary--text">
                                        Operador
                                    </h4>
                                </v-col>
                            </v-row>
                            <v-divider class="mb-2 mt-n4"></v-divider> -->
                            <v-select
                                clearable
                                chips
                                hide-selected
                                :items="opciones.tarifas.operator"
                                item-text="human"
                                item-value="encoded"
                                v-model="managementFilterForm.operator"
                                label="Operador"
                            >
                                <template #selection="{ item }">
                                    <v-chip color="primary" class="white--text">
                                        <v-icon> mdi-signal-variant </v-icon>
                                        {{ item.encoded }}
                                    </v-chip>
                                </template>
                            </v-select>
                        </v-card>
                    </v-col>
                    <v-col cols="12">
                        <v-card elevation="0" text class="mt-1 pa-2">
                            <!-- <v-row>
                                <v-col md="12" class="mb-md-1 mt-md-1">
                                    <h4 class="font-weight-light primary--text">
                                        Familia
                                    </h4>
                                </v-col>
                            </v-row>
                            <v-divider class="mb-2 mt-n4"></v-divider> -->
                            <v-select
                                clearable
                                hide-selected
                                chips
                                :items="Families"
                                v-model="managementFilterForm.category"
                                label="Familia"
                            >
                                <template #selection="{ item }">
                                    <v-chip color="purple" class="white--text">
                                        <v-icon> mdi-family-tree </v-icon>
                                        {{ item }}
                                    </v-chip>
                                </template>
                            </v-select>
                        </v-card>
                    </v-col>
                    <v-col cols="12">
                        <v-card elevation="0" text class="mt-1 pa-2">
                            <!-- <v-row>
                                <v-col md="12" class="mb-md-1 mt-md-1">
                                    <h4 class="font-weight-light primary--text">
                                        Tipo de Pago
                                    </h4>
                                </v-col>
                            </v-row>
                            <v-divider class="mb-2 mt-n4"></v-divider> -->
                            <v-select
                                clearable
                                hide-selected
                                chips
                                :items="['postpaid', 'prepaid']"
                                v-model="managementFilterForm.payment_type"
                                label="Tipo de pago"
                            >
                                <template #selection="{ item }">
                                    <v-chip
                                        color="orange darken-2"
                                        class="white--text"
                                    >
                                        <v-icon> mdi-credit-card </v-icon>
                                        {{ item }}
                                    </v-chip>
                                </template>
                            </v-select>
                        </v-card>
                    </v-col>
                    <v-col cols="12">
                        <v-card elevation="0" text class="mt-1 pa-2">
                            <!-- <v-row>
                                <v-col md="12" class="mb-md-1 mt-md-1">
                                    <h4 class="font-weight-light primary--text">
                                        Segmento
                                    </h4>
                                </v-col>
                            </v-row>
                            <v-divider class="mb-2 mt-n4"></v-divider> -->
                            <v-select
                                clearable
                                hide-selected
                                chips
                                :items="opciones.tarifas.segment"
                                item-text="human"
                                item-value="encoded"
                                v-model="managementFilterForm.segment"
                                label="Segmento"
                            >
                                <template #selection="{ item }">
                                    <v-chip
                                        color="yellow darken-2"
                                        class="white--text"
                                    >
                                        <v-icon> mdi-call-merge </v-icon>
                                        {{ item.human }}
                                    </v-chip>
                                </template>
                            </v-select>
                        </v-card>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-actions class="justify-end">
                <v-btn text color="warning" @click="reset"> Limpiar </v-btn>
                <v-btn
                    text
                    color="red"
                    @click="isOpenManagementFilterForm = false"
                >
                    Cerrar
                </v-btn>
                <!-- <v-btn
                    color="primary"
                    @click="submit"
                >
                </v-btn> -->
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { clone } from '@/util/libUtil.js';
import { mapState, mapActions } from 'vuex';
import defaultManagementFilters from '@/util/management/defaultManagementFilters.js';

export default {
    name: 'ManagementFilterForm',
    data: () => ({
        Families: ['convergent', 'mobile_line', 'fixed_line'],
    }),
    methods: {
        changeValue() {
            this.managementFilterForm.is_active = Number(
                !this.managementFilterForm.is_active
            );
        },
        reset() {
            this.$store.commit(
                'ManagementBase/managementFilterForm',
                clone(defaultManagementFilters)
            );
        },
    },
    computed: {
        isOpenManagementFilterForm: {
            get() {
                return this.$store.state.ManagementBase.managementFilters
                    .isOpen;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/isOpenManagementFilterForm',
                    val
                );
            },
        },
        managementFilterForm: {
            get() {
                return this.$store.state.ManagementBase.managementFilters.form;
            },
            set(val) {
                this.$store.commit('ManagementBase/managementFilterForm', val);
            },
        },
        opciones() {
            return JSON.parse(localStorage.getItem('opciones'));
        },
    },
};
</script>